import { render, staticRenderFns } from "./Myinfo.vue?vue&type=template&id=0b0c8c68&scoped=true&"
import script from "./Myinfo.vue?vue&type=script&lang=js&"
export * from "./Myinfo.vue?vue&type=script&lang=js&"
import style0 from "./Myinfo.vue?vue&type=style&index=0&id=0b0c8c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c8c68",
  null
  
)

export default component.exports